import React from 'react';
import { useTranslate } from '../../lib/i18n';
import { formatMessageTime } from '../../utils/timeFormatters';
import { MessageDisplay } from '../MessageDisplay';

interface Props {
  time: number | string;
  content: string;
  isSameAuthorAsPrev?: boolean;
}

const OperatorMessage = ({ time, content, isSameAuthorAsPrev = false }: Props) => {
  const t = useTranslate();
  const formattedTime = formatMessageTime(time);

  return (
    <div className="mt-2 flex justify-end">
      <div className="max-w-[80%] animate-slide-up">
        <div className="flex flex-col items-end">
          <div className="mb-2 w-full">
            {!isSameAuthorAsPrev && (
              <div className="flex items-center justify-end space-x-2">
                <span className="text-xs font-semibold">{t('operatorMessage.operator')}</span>
                <span className="text-xs text-muted-foreground">{formattedTime}</span>
              </div>
            )}
          </div>
          <div className="inline-block max-w-full rounded-[10px] rounded-tr-none border bg-card px-4 py-2 text-left text-sm text-card-foreground">
            <div className="overflow-wrap-anywhere whitespace-pre-wrap break-words">
              {content && <MessageDisplay text={content} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OperatorMessage;
